import React, { useState } from "react";
import { Formik, Form, Field } from "formik";
import Axios from "../../Helpers/Universal/Axios/Axios";
import API from "../../Helpers/Constants/EndPoints/Api";
import { ConfigSchema } from "../../Helpers/Constants/Schemas";

const ConfigModal = ({ modalData, setModalData, setVisible, setData }) => {
  // Split seconds into hours, minutes, seconds
  const secondsToHMS = (totalSeconds) => {
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    return { hours, minutes, seconds };
  };

  const initialHMS = modalData?.data?.value
    ? secondsToHMS(modalData?.data?.value)
    : { hours: 0, minutes: 0, seconds: 0 };

  const hide = () => setModalData((prev) => ({ ...prev, visible: false }));

  const handleSubmit = async (values) => {
    try {
      setVisible((prev) => ({ ...prev, loader: true }));

      // Convert selected time to total seconds
      const totalSeconds =
        Number(values.hours) * 3600 +
        Number(values.minutes) * 60 +
        Number(values.seconds);

      const { status } = await Axios.patch(API.CONFIG.UPDATE, {
        configId: modalData?.data?._id,
        value: totalSeconds,
      });

      if (status) {
        setData((prev) =>
          prev?.map((slot) =>
            slot._id === modalData?.data?._id
              ? { ...slot, value: totalSeconds }
              : slot
          )
        );
      }
    } catch (err) {
      console.log("ERROR==>", err);
    } finally {
      setVisible((prev) => ({ ...prev, loader: false }));
      hide();
    }
  };

  // Generate options for select inputs
  const generateOptions = (max) => Array.from({ length: max + 1 }, (_, i) => i);

  return (
    <div className="bg_viewpopup" style={{ zIndex: "999999" }}>
      <div className="successfullModal successfull delete-modal bg-white p-4 pb-0 w-50 top-50 start-50 end-0 border border-secondary rounded text-center position-absolute">
        <div >
          <label className="cross-btns" onClick={hide}>
            ×
          </label>
        </div>
        <div className="modal-body mt-0 p-0">
          <Formik
            initialValues={initialHMS}
            onSubmit={handleSubmit}
          >
            {({ isSubmitting }) => (
              <Form className="page-from">
                <div className="inner-form">
                  <div className="row">
                    <div className="col-md-4 mb-3">
                      <label>Hours</label>
                      <Field as="select" name="hours" className="form-control">
                        {generateOptions(24).map((h) => (
                          <option key={h} value={h}>
                            {h}
                          </option>
                        ))}
                      </Field>
                    </div>
                    <div className="col-md-4 mb-3">
                      <label>Minutes</label>
                      <Field as="select" name="minutes" className="form-control">
                        {generateOptions(59).map((m) => (
                          <option key={m} value={m}>
                            {m}
                          </option>
                        ))}
                      </Field>
                    </div>
                    <div className="col-md-4 mb-3">
                      <label>Seconds</label>
                      <Field as="select" name="seconds" className="form-control">
                        {generateOptions(59).map((s) => (
                          <option key={s} value={s}>
                            {s}
                          </option>
                        ))}
                      </Field>
                    </div>

                    <div className="col-md-12 mb-0 mt-3 text-center">
                      <button
                        disabled={isSubmitting}
                        className="btn bg-gradient-dark d-block btn-lg mb-1"
                        type="submit"
                      >
                        Save
                      </button>
                    </div>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </div>
  );
};

export default ConfigModal;
